import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { Cover } from '../../../music24/components/primitives/Cover';
import { CatalogReleaseEvent } from '../../../../redux/api/fymAPI.types';
import { releaseMessages } from './releaseMessages';
import { linkedCardBody } from './linkedCardBody';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the release cards; each part uses its own slice of it */
import styles from './ReleaseCards.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReleaseLinkedCardProps {
  event: CatalogReleaseEvent;
  disabled: boolean;
  onSee: (event: CatalogReleaseEvent) => void;
  onDismiss: (event: CatalogReleaseEvent) => void;
}

/** Design g3, the green card: the unreleased row is now the released track. */
const ReleaseLinkedCardComponent: React.FC<ReleaseLinkedCardProps> = ({ event, disabled, onSee, onDismiss }) => {
  const intl = useIntl();
  const see = useCallback(() => onSee(event), [event, onSee]);
  const dismiss = useCallback(() => onDismiss(event), [event, onDismiss]);

  return (
    <div className={styles.card} role="status">
      <Cover src={event.candidate.artworkUrl ?? undefined} label={event.title} size={44} />
      <div className={styles.grow}>
        <span className={styles.title}>{intl.formatMessage(releaseMessages.linkedTitle, { title: event.title })}</span>
        <span className={styles.body}>{linkedCardBody(intl, event)}</span>
      </div>
      <SMLButton size="sm" outline omitCap onClick={see}>
        {intl.formatMessage(releaseMessages.seeRelease)}
      </SMLButton>
      <button
        type="button"
        className={styles.close}
        aria-label={intl.formatMessage(releaseMessages.close)}
        disabled={disabled}
        onClick={dismiss}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export const ReleaseLinkedCard = TypedMemo(ReleaseLinkedCardComponent);
